import { render, staticRenderFns } from "./eventShow.vue?vue&type=template&id=0ff0cd27&scoped=true&"
import script from "./eventShow.vue?vue&type=script&lang=js&"
export * from "./eventShow.vue?vue&type=script&lang=js&"
import style0 from "./eventShow.vue?vue&type=style&index=0&id=0ff0cd27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0cd27",
  null
  
)

export default component.exports